import { FC } from "react";

interface SubscribeIconSVGProps {
    className?: string;
    strokeWidth?: string;
}

const SubscribeIconSVG: FC<SubscribeIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.66699 28C2.66688 25.9471 3.25917 23.9378 4.37279 22.2132C5.4864 20.4886 7.07402 19.122 8.94512 18.2774C10.8162 17.4327 12.8913 17.146 14.9213 17.4516C16.9514 17.7571 18.8501 18.642 20.3897 20M21.3337 25.3333L24.0003 28L29.3337 22.6667M20.0003 10.6667C20.0003 14.3486 17.0156 17.3333 13.3337 17.3333C9.65176 17.3333 6.66699 14.3486 6.66699 10.6667C6.66699 6.98477 9.65176 4 13.3337 4C17.0156 4 20.0003 6.98477 20.0003 10.6667Z"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SubscribeIconSVG;
